import { atom } from "jotai";

export const pointsAtom = atom(0);

export const handlePointsAtom = atom<null, number>(
    null,
    (get, set, value) => set(pointsAtom, get(pointsAtom) + value)
)
